var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62533 6.49935C9.62533 6.15417 9.3455 5.87435 9.00033 5.87435C8.65515 5.87435 8.37533 6.15417 8.37533 6.49935L8.37533 8.37437H6.50033C6.15515 8.37437 5.87533 8.65419 5.87533 8.99937C5.87533 9.34455 6.15515 9.62437 6.50033 9.62437H8.37533V11.4993C8.37533 11.8445 8.65515 12.1243 9.00033 12.1243C9.3455 12.1243 9.62533 11.8445 9.62533 11.4993L9.62533 9.62437H11.5003C11.8455 9.62437 12.1253 9.34455 12.1253 8.99937C12.1253 8.65419 11.8455 8.37437 11.5003 8.37437H9.62533V6.49935Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00033 0.0410156C4.05278 0.0410156 0.0419922 4.0518 0.0419922 8.99935C0.0419922 13.9469 4.05278 17.9577 9.00033 17.9577C13.9479 17.9577 17.9587 13.9469 17.9587 8.99935C17.9587 4.0518 13.9479 0.0410156 9.00033 0.0410156ZM1.29199 8.99935C1.29199 4.74215 4.74313 1.29102 9.00033 1.29102C13.2575 1.29102 16.7087 4.74215 16.7087 8.99935C16.7087 13.2565 13.2575 16.7077 9.00033 16.7077C4.74313 16.7077 1.29199 13.2565 1.29199 8.99935Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.68dfe333cec2631604a45bbf9f2b02ef.svg";